import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ViewPdfModalPage } from "./view-pdf-modal.page";
import { ModalComponentModule } from "../modal-component/modal-component.module";

@NgModule({
  declarations: [ViewPdfModalPage],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    PdfViewerModule,
    ModalComponentModule,
  ],
  exports: [ViewPdfModalPage],
})
export class ViewPdfModalModule {}
